<!-- 商品详情 -->
<template>
  <div class="preview_picture_w">
    <div>
      <div class="pic-block">
        <img
          class="w100 h100"
          :src="
            currentPreviewUrl
              ? currentPreviewUrl + '!378'
              : require('@/assets/images/default_1.jpg')
          "
          alt=""
        >
      </div>

      <div class="pic_list_w d_flex">
        <span
          class="
            switch_btn
            last_btn
            d_flex
            align_item_c
            justify_content_c
            bc_EBEBEB
          "
          @click="onPreviewLast"
        ><img
          src="@/assets/images/lt.png"
          alt=""
        ></span>
        <div class="pic_i d_flex justify_content_start">
          <img
            v-for="(item, index) in picList"
            :key="index"
            class="small_pic"
            :class="index === activeIndex ? 'active_preview' : ''"
            :src="item + '!106'"
            alt=""
            :style="{
              transform: `translateX(${index * previewImgWidth}px)`,
              left: `${index * 10}px`,
            }"
            @click="onPreviewClick(item)"
          >
        </div>

        <span
          class="
            switch_btn
            next_btn
            d_flex
            align_item_c
            justify_content_c
            bc_EBEBEB
          "
          @click="onPreviewNext"
        ><img
          src="@/assets/images/gt.png"
          alt=""
        >
        </span>
      </div>
    </div>

    <div class="d_flex">
      <div
        v-for="(item, index) in previewOptions"
        :key="item.title"
        style="margin-right: 10px;"
        class="fz12 c_ccc"
        :class="item.disabled ? 'pre_i_disable' : 'pre_i_allow'"
      >
        <a :href=" item.tab ? '#'+item.tab : 'javascript:void(0)'" class="pre_i d_flex align_item_c" @click="onPreviewOptionsClick(item)">
          <img :src="!item.disabled ? item.active_icon : item.icon" alt="">
          <span>{{ item.title }}</span>
        </a>
      </div>
    </div>

    <!-- 海报 -->
    <el-dialog
      :visible.sync="showShare"
      width="375px"
      append-to-body
      :show-close="false"
      top="10vh"
      custom-class="share-dialog"
    >
      <div class="share-outer">
        <div class="share-inner" :style="{background:`url(${shareBgPic}) 0 0 /cover no-repeat`}">
          <div class="share-head">
            {{ siteInfo.name }}
          </div>
          <div class="share-body">
            <div class="pro-info">
              <div class="pro-pic-w">
                <img :src="picList[0] + '!300' + '?' + new Date().getTime()" alt="" crossOrigin="anonymous">
              </div>
              <div class="pro-title text_ellipsis">{{ itemDetail.title }}</div>
              <div class="pro-meta">
                <div class="meta-row">
                  <span class="meta-key">价格：</span>
                  <span class="meta-val c-EC3F22"><span v-if="itemDetail.priceUnit !== 'mianyi'">{{ itemDetail.price }}</span>{{ priceUnitKey[itemDetail.priceUnit] }} </span>
                </div>
                <div class="meta-row">
                  <span class="meta-key">面积/数量：</span>
                  <span class="meta-val">{{ itemDetail.quantity }}{{ quantityUnitKey[itemDetail.quantityUnit] }}</span>
                </div>
                <div class="meta-row">
                  <span class="meta-key">流转年限：</span>
                  <span class="meta-val">{{ itemDetail.deadline }}{{ deadlineUnitConversion(itemDetail.deadlineUnit) }}</span>
                </div>

                <div
                  class="optional d_flex justify_content_sb align_item_c fz14 c_808080 ps_flag"
                >
                  <div class="d_flex align_item_c location-wrapper">
                    <i class="el-icon-location-outline fz18" /><span
                      class="location_name fz14"
                    >{{ itemDetail.area }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="dashed-line" />
            <div class="code-outer">
              <canvas id="qrCode" />
              <div class="code-desc">识别或扫描二维码查看更多信息</div>
            </div>
          </div>
        </div>
        <div class="code-save" @click="onDownShareCodeClick">
          <span>保存分享图</span>
          <span class="code-save-icon">
            <img :src="require('@/assets/images/save-qrcode.png')" alt="">
          </span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { user_playAuth } from '@/api/user'
import { createPlayer, downloadFile, imageToBase64 } from '@/utils'
import { mapGetters } from 'vuex'
import bus from '@/utils/bus'
import qrcode from 'qrcode'
import html2canvas from 'html2canvas'

export default {
  components: {
  },
  props: {
    itemDetail: {
      type: Object,
      default: () => {}
    },
    picList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentPreviewIndex: 0,
      previewImgWidth: 106,
      activeIndex: 0,
      currentPreviewUrl: '',

      preIconIndex: -1,

      hasTargetLocation: false,

      checkVideo: 'picture',
      checkPlay: 'play',

      playauth: '', // 播放凭证

      initComplete: false,
      showShare: false,
      qrcodeUrl: ''
    }
  },
  computed: {
    ...mapGetters(['stateAllKey', 'siteInfo', 'priceUnitKey', 'deadlineUnitKey', 'quantityUnitKey']),
    previewOptions() {
      return [
        {
          icon: require('@/assets/images/g_icon_1.png'),
          title: '全景',
          active_icon: require('@/assets/images/g_icon_5.png'),
          disabled: !this.hasVrUrl,
          type: 'vr',
          link: this.itemDetail.vrUrl
        },
        {
          icon: require('@/assets/images/g_icon_2.png'),
          title: '视频',
          active_icon: require('@/assets/images/g_icon_6.png'),
          disabled: !this.hasVideo,
          type: 'video',
          tab: 'tab3'
        },
        {
          icon: require('@/assets/images/g_icon_4.png'),
          title: '分享',
          active_icon: require('@/assets/images/g_icon_8.png'),
          disabled: this.hasShare,
          type: 'share'
        }
      ]
    },
    hasVrUrl() {
      return this.itemDetail.vrUrl
    },
    hasVideo() {
      return this.itemDetail.videos.length
    },
    hasShare() {
      return false
    },
    shareBgPic() {
      return require('@/assets/images/pro-share-bg.png')
    },
    // 格式化金额（小数点）
    formatMoney: function() {
      return function(num) {
        return Number(num).toLocaleString()
      }
    },
    imageToBase64: function() {
      return async function(url) {
        console.log('imageToBase64', await imageToBase64(url))
        return await imageToBase64(url)
      }
    }
  },
  mounted() {
    this.setPreviewUrl(this.picList[0])
    this.initComplete = true
  },
  methods: {
    // 上一张 click
    onPreviewLast() {
      this.currentPreviewIndex--
      if (this.currentPreviewIndex < 0) {
        this.currentPreviewIndex = this.picList.length - 1
      }
      this.picList.unshift(this.picList[this.picList.length - 1])
      this.picList.pop()
      this.setPreviewUrl(this.picList[this.activeIndex])
    },
    // 下一张 click
    onPreviewNext() {
      this.currentPreviewIndex++
      if (this.currentPreviewIndex > this.picList.length - 1) {
        this.currentPreviewIndex = 0
      }
      this.picList.push(this.picList[0])
      this.picList.shift()
      this.setPreviewUrl(this.picList[this.activeIndex])
    },
    // 预览图 click
    onPreviewClick(url) {
      const activeIndex = this.picList.findIndex((i) => i === url)
      this.currentPreviewUrl = this.picList[activeIndex]
      this.setActiveIndex(activeIndex)
    },
    // 设置预览图url
    setPreviewUrl(url) {
      this.currentPreviewUrl = url
    },
    // 设置预览index
    setActiveIndex(index) {
      this.activeIndex = index
    },
    // 图标项 click
    onPreviewOptionsClick(item) {
      if (item.disabled) return
      if (item.link) {
        window.location.href = item.link
      }
      if (item.tab) {
        bus.$emit('PREVIEW:OPTION', item.tab)
      }
      if (item.type === 'share') {
        this.handleShare()
      }
    },
    // 处理分享
    handleShare() {
      this.showShare = true
      this.$nextTick(() => {
        this.generateShareQrcode()
      })
    },
    deadlineUnitConversion(param) {
      return this.deadlineUnitKey[param]
    },
    // 生成海报二维码
    generateShareQrcode() {
      qrcode.toDataURL(document.querySelector('#qrCode'), location.href, {
        color: {
          dark: '#000',
          light: '#fff'
        }
      },)
    },
    // 下载分享码 click
    onDownShareCodeClick() {
      html2canvas(document.querySelector('.share-inner'), {
        allowTaint: true,
        useCORS: true
      }).then(canvas => {
        downloadFile(canvas.toDataURL('image/png'), '分享海报')
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.location_name  {
  width: 280px; /* 根据需要设置宽度 */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.c-EC3F22{
  color: #EC3F22 !important;
}
::v-deep .share-dialog{
  .el-dialog__header,.el-dialog__body{
    padding: 0;
  }
}
.share-outer{
  position: relative;
  .code-save{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 72px;
    display: flex;
    justify-content: center;
    cursor: pointer;
    margin: auto;
    .code-save-icon{
      margin: 0 0 0 10px;
    }
  }
}
.share-inner{
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 735px;
  padding: 20px 0;
  box-sizing: border-box;
  .share-head{
    color: #fff;
    font-size: 24px;
    letter-spacing: 2px;
    margin: 30px 0;
  }
  .pro-pic-w{
    &>img{
      display: block;
      width: 300px;
      height: 200px;
      border-radius: 4px;
    }
  }
  .share-body{
    padding: 20px 20px 40px 20px;
    border-radius: 4px;
    background: radial-gradient(circle at 96% 55%, transparent 9px, #fff 0) 14px 25px;
    .pro-info{
      width: 300px;
    }
    .pro-title{
      color: #333;
      font-size: 15px;
      font-weight: bold;
      margin: 10px 0;
    }
    .pro-meta{
      .meta-row{
        margin: 10px 0;
      }
      .meta-key{
        color: #999;
      }
      .meta-val{
        font-weight: bold;
        color: #333;
      }
    }
    .code-outer{
      text-align: center;
      #qrCode{
        width: 135px !important;
        height: 135px !important;
      }
      .code-desc{
        margin: 0px 0;
      }
    }
  }
  .dashed-line{
    border: 1px dashed #ccc;
    margin: 0px 30px;
    margin-top: 15px;
  }
}
.preview_picture_w {
  width: 380px;
  .pre_i {
    display: inline-flex;
    height: 30px;
    padding: 0 19px;
    border: 1px solid;
    & > span {
      margin: 0 0 0 4px;
    }
  }
  .pre_i_active {
    // color: #0983cc;
    // border-color: #0983cc;
  }
  .pre_i_disable {
    // opacity: 0.4;
    color: #ccc;
    border-color: #ccc;
    cursor: no-drop;
  }
  .pre_i_allow {
    color: #0983cc;
    border-color: #0983cc;
    cursor: pointer;
  }
  .main_w,
  .pic-block {
    overflow: hidden;
    position: relative;
    border: 1px solid #e6e6e6;
    margin: 0 0 10px 0;
    .pro-state {
      position: absolute;
      top: 0;
      left: 0;
      width: 97px;
      height: 97px;
      line-height: 165px;
      transform: translate(-50px, -50px) rotateZ(-45deg);
      text-align: center;
      color: #fff;
      font-size: 12px;
    }
  }
  .main_w {
    height: 241px;

    &:hover {
      .close_video_icon {
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        margin: 5px;
      }
    }
    & > img {
      display: block;
      width: 100%;
      height: 100%;
    }
    .video_player {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .pic-block {
    height: 240px;
  }
  .pic_list_w {
    overflow: hidden;
    height: 57px;
    margin: 10px 0;
  }
  .switch_btn {
    position: static;
    width: 20px;
    height: 100%;
    cursor: pointer;
    z-index: 1;
  }
  .last_btn {
    margin: 0 5px 0 0;
  }
  .pic_i {
    position: relative;
    width: 470px;
    transition: all 1s;
    &::-webkit-scrollbar {
      display: none;
    }
    & {
      scrollbar-width: none; //火狐
    }
  }
  .small_pic {
    position: absolute;
    top: 0;
    left: 0;
    width: 110px;
    height: 100%;
    padding: 2px;
    box-sizing: border-box;
    cursor: pointer;
    &:last-child {
      margin: 0;
    }
  }
  .active_preview {
    border: 2px solid #2caeff;
    padding: 0 !important;
  }
  .next_btn {
    margin: 0 0 0 5px;
  }
}
</style>
